import(/* webpackMode: "eager" */ "/app/app/admin/layout.tsx");
